import Box from '@mui/material/Box';
import { ContentCopyExtension } from 'common/ContentCopyExtension/ContentCopyExtension';
import { Tooltip } from '../components/Tooltip/Tooltip';
import React from 'react';
import { palette } from 'theme/palette';
import { pxToRem } from '../utils/fonts';

export type StickyCopyExtensionProps = {
  children: React.ReactElement;
  value: string;
};

const stickyWrapperSx = {
  width: `calc(100% + ${pxToRem(25)})`,
  '& button': {
    position: 'sticky',
    right: pxToRem(-10),
    background: palette.background.default,
    '&: hover': {
      backgroundColor: '#e6eaeb !important',
    },
    height: pxToRem(22),
    width: pxToRem(22),
  },
  '& span, a': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
};

export const StickyCopyExtension: React.FC<StickyCopyExtensionProps> = ({ children, value }) => {
  return (
    <Box sx={stickyWrapperSx}>
      <ContentCopyExtension value={value}>
        <Tooltip
          showArrow={true}
          placement={'bottom'}
          enterDelay={1000}
          enterTouchDelay={1000}
          enterNextDelay={1000}
          variant="dark"
          title={value}
        >
          {children}
        </Tooltip>
      </ContentCopyExtension>
    </Box>
  );
};
